<template>
  <div class="squareContent">
    <div
      :class="getClass"
      :style="{
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: this.pSize + 'px',
        width: this.pSize + 'px',
        zIndex: (50 - this.pIndex),
        background: '#000000cc'
      }"
      v-if="!isSelected && this.pProject.projectType == 2"
      @mouseenter="handleMouseOver"
      @mouseleave="handleMouseLeave"
      @touchstart="handleMouseOver"
      @touchend="handleMouseLeave"
    >
      <!-- PROJECT PREVIEW -->
      <div :style="getSquareStyle">
        <transition name="fade">
          <div v-if="this.pProject.projectType == 2" :style="getNameStyle">
            <div class="nameBox" v-if="this.isShowDetails">

              <div class="aboutMe" :style="getFontSize(.22)">
                Creative technologist working in hardware and software.
                <br><br>
                I am a partner of the creative practice <a href="http://studioquasi.com" :style="getFontSize(.22)" target="_new">Studio Quasi</a>.
                <br><br>
                I previously lead R&D at the Havas Media <a href="http://www.themadscilab.com" :style="getFontSize(.22)" target="_new">technology research lab</a>.
                <br><br>
                <a :style="getFontSize(.22)" @click="swapDetails(false)">back</a>
              </div>
            </div>
            <div class="nameBox" :style="getFontSize(.55)" v-else-if="!this.isShowDetails">
              <span :style="getTitleStyle(.19)">Adam<br />Tyler<br />Lassy</span>
    
              <div class="infoBottom">
                <div class="projectNameTitle" :style="getFontSize(.18)">
                  Engineer & Designer<br /><br />adamlassy@gmail.com<br /><br />
                </div>
                <div class="nameBoxLinks" :style="getFontSize(.13)">
                  <a
                    href="#"
                    @click="setCategoryFilter(4)"
                    :style="this.getLinkStyle(9)"
                    v-if="!this.isMobile"
                    >{{ !this.isShowGrid ? 'Grid View' : 'One Page View' }}</a>
                  <a
                    href="#"
                    @click="setCategoryFilter(0)"
                    :style="this.getLinkStyle(0)"
                    v-if="this.isMobile"
                    >All</a>
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(3)"
                    :style="this.getLinkStyle(3)"
                    >Featured</a
                  >
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(1)"
                    :style="this.getLinkStyle(1)"
                    >Software</a
                  >
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(2)"
                    :style="this.getLinkStyle(2)"
                    >Hardware</a
                  >

                </div>
                <!--div class="nameBoxLinks" :style="getFontSize(.16)">
                  <a
                    href="#"
                    @click="setCategoryFilter(0)"
                    :style="this.getLinkStyle(0)"
                    >All</a
                  >
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(3)"
                    :style="this.getLinkStyle(3)"
                    >Featured</a
                  >
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(1)"
                    :style="this.getLinkStyle(1)"
                    >Software</a
                  >
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(2)"
                    :style="this.getLinkStyle(2)"
                    >Hardware</a
                  >
                  |
                  <a
                    href="#"
                    @click="setCategoryFilter(4)"
                    >Grid</a
                  >

                </div-->
              </div>

              <div class="squareOverlay" @click="swapDetails(true)">

              </div>
            </div>
          </div>
        </transition>

      </div>
    </div>

    <div
      :class="getClass"
      :style="{
        position: 'absolute',
        left: '0px',
        top: '0px',
        height: this.pSize + 'px',
        width: this.pSize + 'px',
        zIndex: this.isOver ? 1000 : 10,
      }"
      @mouseenter="handleMouseOver"
      @mouseleave="handleMouseLeave"
      @touchstart="handleMouseOver"
      @touchend="handleMouseLeave"
      @click="selectProject()"
      v-if="!isSelected && this.pProject.projectType != 2"
    >
      <!-- PROJECT PREVIEW -->
      <div :style="getSquareStyle">
        <transition name="fade">
          <img
            v-bind:src="this.getImgPath"
            :style="{
              objectPosition: this.getImgOffset,
            }"
            class="projectImg"
            @load="onImgLoad"
            v-show="this.imgLoaded"
            v-if="this.pProject.projectType != 2"
          />
        </transition>

        <transition name="fade">
          <div
            v-if="this.isOver && this.pProject.introGif"
            :style="{ width: '100%', height: '100%' }"
          >

              <img  
                :src="this.getIntroGifPath" 
                class="introVideoC" 
                :style="getGifSize" 
              />

              <!--vueVimeoPlayer
                ref="player"
                :video-id="this.pProject.titleVideo"
                loop="true"
                controls="false"
                :options="{ muted: 'true' }"
                :playerWidth="this.getVideoWidth"
                :playerHeight="this.getVideoHeight"
                autoplay="true"
                @ready="onReady"
                @loaded="onLoaded"
                :key="this.keyIndex"
              ></vueVimeoPlayer-->

            </div>
        </transition>
      </div>

      <div
        :style="{
          position: 'absolute',
          left: '0px',
          top: '0px',
          height: '100%',
          width: '100%',
          overflow: 'hidden'
        }"
      >
        <transition name="fade">
          <div :class="getProjectClass(this.pProject.id)" :style="getContentStyle" v-show="this.isOver && this.pProject.projectType != 2" v-if="!isSelected">
            <div class="projectContent" :style="getFontSize(.15)">
              {{ this.pProject.title }}
              <div class="projectContentClient" :style="getFontSize(.15)">{{ getProjectClient }}</div>
              <div class="projectContentStudio" :style="getFontSize(.13)">{{ getProjectStudio }}</div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- 
      PROJECT DETAIL 
      -->
    <div
      v-if="isSelected"
      :style="{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        left: '0px',
        top: '0px',
        overflow: 'scroll',
        background: '#e1e1e1',
      }"
      ref="frame"
    >
      <div class="header" :style="getHeaderStyle">
        <img
          v-bind:src="this.getBannerImgPath"
          :style="{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            boxShadow:
              '0 3px 3px rgba(0, 0, 0, 0.06), 0 3px 3px rgba(0, 0, 0, 0.06)',
          }"
        />
        <div
          :style="{
            position: 'absolute',
            left: '0px',
            bottom: '0px',
            width: '100%',
            height: '100%',
          }"
        >
        

          <div class="projectTitleContent" :style="{width: (this.isMobile ? '80vw' : '70vw')}" v-if="this.headerOpen == true">
            <div :style="{ position: 'absolute', bottom: '30px' }">
              <div class="title" :style="getTitleFontSize((this.isMobile ? 1.5 : 1) * .045)">{{ this.pProject.title }}</div>
              <div class="subtitle" :style="getTitleFontSize((this.isMobile ? 1.5 : 1) * .025)">{{ getProjectClient }}</div>
            </div>
          </div>

          <transition name="fade">
            <div class="projectTitleContent" :style="{width: (this.isMobile ? '80vw' : '70vw')}" v-if="this.headerOpen != true">
              <div :style="{ position: 'absolute', bottom: '5px' }">
                <div class="titleSmall">{{ this.pProject.title }}</div>
                <div class="subtitleSmall">{{ getProjectClient }}</div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div
        :style="{
          paddingTop: '30vh',
          position: 'absolute',
          left: '0px',
          right: '0px',
          width: '100%',
          backgroundColor: '#e1e1e1',
          zIndex: '20',
          alignItems: 'center',
          justifyContent: 'center',
        }"
      >
        <div @click="close()" class="backButton">{{ getBackButton }}</div>
        <div class="projectMainContent" :style="{width: (this.isMobile ? '80vw' : '70vw')}">
          <div v-if="this.pProject.adam_lassy_studio">
            <div class="subtitle">
              <span class="thinSubtitle">Studio:</span>
              {{ this.pProject.adam_lassy_studio.name }}
              <span v-if="!this.pProject.adam_lassy_studio.url">{{
                this.pProject.adam_lassy_studio.name
              }}</span>
            </div>
          </div>

          <div v-if="this.pProject.projectRoll">
            <div class="roll">
              <span class="thinSubtitle">Project Role:</span>
              {{ this.pProject.projectRoll }}
            </div>
          </div>

          <div class="teamRoll" v-if="this.pProject.creditArr">
            <div
              v-for="(_project, index) in this.pProject.creditArr.split('\n')"
              :key="index"
            >
              <span class="teamRollTitle">{{ _project.split("|")[0] }}:</span>
              {{ _project.split("|")[1] }}
            </div>
          </div>

          <!--div v-if="this.pProject.subTitle != ''">
            <p>{{ this.pProject.subTitle }}</p>
          </div-->

          <ImageCarousel
            :pWidth="getCarouselWidth"
            :pHeight="getCarouselHeight"
            :pThumbDiv="10"
            :style="{ paddingTop: '40px' }"
            :pMediaArr="getMediaArray()"
          />

          <div
            v-html="this.pProject.content"
            :style="{ paddingTop: '30px', paddingBottom: '50px' }"
            class="contentBlock"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";

import StrapiService from "@/services/StrapiService.js";

//import { vueVimeoPlayer } from "vue-vimeo-player";

import ImageCarousel from "@/components/ImageCarousel.vue";
import { EventBus } from "@/event-bus.js";

export default {
  components: { ImageCarousel },
  props: {

    pProject: {
      type: Object,
      return: null,
    },
    pSize: {
      type: Number,
      return: 1280,
    },
    pIndex: {
      type: Number,
      return: 0,
    },
    pSelectedProjectIndex: {
      type: Number,
      return: -1,
    },
    pLocation: {
      type: Array,
      default: function () {
        return [];
      },
    },
    pAtEnd: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tick: {
      type: Number,
      default: 0,
    },
    boxSize: {
      type: Number,
      default: 0,
    },
    gridMargin: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: Number,
      default: 1,
    },
    pSizeSquare: {
      type: Number,
      default: 1
    }
  },
  watch: {

    pLocation: function () {
  
      this.isFlying = true;
      let _duration = .75

      gsap.to(".tween" + this.$vnode.key, {
        duration: _duration,
        ease: "circ.easeInOut",
        x: this.pLocation[0],
        y: this.pLocation[1],
        width: this.pSize,
        height: this.pSize,
        delay: (this.pIndex / 7) * .05
      });

      setTimeout(() => {
          this.isFlying = false;
        }, (_duration));
  
      //Load video
      //this.$refs.player.load(this.pProject.titleVideo);
      this.keyIndex++;
    },
    pSelectedProjectIndex: function (_i) {
      console.log(_i);
      this.headerOpen = true;
    },
  },
  methods: {

    getTitleStyle: function(_size) {

      console.log(this.pSize)
      return {
        textDecoration: (this.isOver ? 'underline' : ''),
        color: (this.isOver ? '#33cc33' : '#ffffff'),
        fontSize: (this.pSize * _size) + 'px',
        lineHeight: (this.pSize * _size) + 'px' 
      }
    },

    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor;
      
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        this.isMobile = true;
      }
      else if (/android/i.test(userAgent)) {
        this.isMobile = true;
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.isMobile = true;
      }
      else {
        this.isMobile = false;
      }
    },
  
    swapDetails: function(_show) {
      this.isShowDetails = _show
    },

    getProjectClass: function (_id) {

      return "rise" + _id
    },

    getFontSize: function (_size) {
      return {
        fontSize: this.boxSize * _size + "px",
        lineHeight: this.boxSize * _size + "px"
      }
    },
    getTitleFontSize: function (_size) {


      let _f = window.innerWidth * _size
      //console.log("title font box size : " + this.boxSize)
      return {
        fontSize: _f + "px",
      }
    },
    setCategoryFilter: function (_f) {

      if (_f == 4) {
        this.isShowGrid = !this.isShowGrid
      } /*else if (this.isShowGrid) {
        this.isShowGrid = false;
      }*/

      //console.log("filter");
      this.selectedFilter = _f
      EventBus.$emit("filter", _f);
    },
    getLinkStyle: function (_index) {
      var _c = {
        fontSize: .14 * this.boxSize + 'px',
      };

      //console.log(">> selected style " + _index + " " + this.selectedFiler)
      if (_index == this.selectedFilter) {

        _c = {
          fontSize: .14 * this.boxSize + 'px',
          textDecoration: 'underline'
        };

      }
      return _c;
    },
    handleDetailScroll() {
      //console.log("s");
      if (this.isSelected) {
        var _state = true;

        if (this.$refs.frame && this.selectedProjectIndex != -1) {
          //console.log(this.$refs.frame.scrollTop);

          if (this.$refs.frame.scrollTop > 150) {
            _state = false;
          } else {
            _state = true;
          }
          //console.log(_state);
          if (_state != this.headerOpen) {
            this.headerOpen = _state;
            //this.toggleHeaderSize(this.headerOpen);
          }
        }
      }
    },
    toggleHeader() {
      this.headerOpen = !this.headerOpen;
      //console.log(this.headerOpen);
      this.toggleHeaderSize(this.headerOpen);
    },
    toggleHeaderSize(_on) {
      //console.log("Toggle Header Size : " + _on);
      var _open = window.innerHeight * 0.3;
      gsap.to(".header", {
        duration: 0.4,
        height: _on ? _open : this.closedSize,
      });
    },
    getSquareSize: function (_size) {
      if (!_size) {
        _size = 1;
      }
      return _size * this.boxSize + (_size - 1) * this.gridMargin;
    },
    close: function () {
      //this.toggleHeader();
      EventBus.$emit("close-project", true);
    },
    /*
    clickEventWindow: function () {
      this.closeCount = 1;
      console.log("Click window.");
      console.log("Count : " + this.closeCount);
    },
    clickModal: function () {
      this.closeCount--;
      console.log("click modal " + this.closeCount);
      if (this.closeCount < 0) {
        this.close();
      }
    },*/
    getMediaArray() {
      if (this.pProject.media_items_1.length > 0) {
        return this.pProject.media_items_1;
      } else if (this.pProject.madsci_media_items.length > 0) {
        return this.pProject.madsci_media_items;
      } else if (this.pProject.image_carousel_1.length > 0) {
        return this.pProject.image_carousel_1;
      }
      return null;
    },
    getMediaArrayCount() {
      if (this.pProject.media_items_1) {
        return this.pProject.media_items_1.length;
      } else if (this.pProject.madsci_media_items) {
        return this.pProject.madsci_media_items.length;
      } else if (this.pProject.image_carousel_1) {
        return this.pProject.image_carousel_1.length;
      }
      return 0;
    },
    selectProject() {
      //console.log(">>> SELECT PROJECT");
      //console.log(this.pProject)

      //if (this.pProject.projectType != 2) {
        EventBus.$emit("select-project", this.pIndex);
      //}
    },
    onProgress(data) {
      //console.log(data);
      if (data > 0) {
        this.playerReady = true;
      }
    },
    onImgLoad() {
      this.imgLoaded = true;
    },
    onLoaded() {
      //console.log("> loaded");
      this.playerLoaded = true;
      this.pause();
    },
    onReady() {
      //console.log("> ready");
      this.playerReady = true;
    },
    play() {
      //console.log("> play");
      //this.$refs.player.setCurrentTime(10.0);
      this.$refs.player.play();
    },
    pause() {
      this.$refs.player.pause();
    },
    handleMouseOver: function () {
      
      if (this.pSelectedProjectIndex < 0) {
        /*if (this.pProject.titleVideo && !this.playerPlaying) {
          this.play();
          this.playerPlaying = true;
        }*/
        //console.log(">>> mouse over ")
        this.isOver = true;

        if (this.pProject.projectType != 2)
        {
          gsap.fromTo(".rise" + this.pProject.id, {
            yPercent: 100
          },
          {
            duration: 0.4,
            yPercent: 0
          });
        }
      }

      if (this.pSizeSquare == 1) {

        let _off = -(this.getSquareSize(2) - this.getSquareSize(1))

        //console.log("*** ENLARGE");
        gsap.to(".tween" + this.$vnode.key, {

          duration: 0.25,
          ease: "circ.easeInOut",
          height: this.getSquareSize(2) + "px",
          width: this.getSquareSize(2) + "px",
          x: "+=" + (this.pAtEnd[0] ? _off : 0),
          y: "+=" + (this.pAtEnd[1] ? _off : 0)

        });
      }
    },
    handleMouseLeave: function () {

      this.isOver = false;
      
      //let _off = (this.getSquareSize(2) - this.getSquareSize(1)) * .5

      if (this.pSizeSquare == 1) {
        //console.log("*** ENLARGE");
        gsap.to(".tween" + this.$vnode.key, {
          duration: 0.25,
          ease: "circ.easeInOut",
          height: this.getSquareSize(1) + "px",
          width: this.getSquareSize(1) + "px",
          x: this.pLocation[0],
          y: this.pLocation[1]
        });
      }
    },
    getMonthName(_index) {
      switch (_index) {
        case 0:
          return "January";
        case 1:
          return "February";
        case 2:
          return "March";
        case 3:
          return "April";
        case 4:
          return "May";
        case 5:
          return "June";
        case 6:
          return "July";
        case 7:
          return "August";
        case 8:
          return "September";
        case 9:
          return "October";
        case 10:
          return "November";
        case 11:
          return "December";
      }
    },
  },
  created() {
    //Mouse wheel
    /*EventBus.$on("is-scroll", (_t) => {
      console.log(_t);
      this.handleDetailScroll();
    });*/
    //if (this.pSelectedProjectIndex != -1) {
    //  window.addEventListener("wheel", this.handleDetailScroll);
    //}
  },
  destroyed() {
    //window.eventEventListener("wheel", this.handleDetailScroll);
  },
  mounted() {

    this.checkDevice()
    //var script = document.createElement("script");
    //script.src = "https://player.vimeo.com/api/player.js";

    /*
    var options01 = {
      id: this.getSrc,
      width: this.getVideoWidth,
      height: this.getVideoHeight,
    };

    var video01Player = new Vimeo.Player(this.getSrc, options01);

    video01Player.setVolume(0);

    video01Player.on("play", function () {
      console.log("Played the first video");
    });
    */

    gsap.to(".tween" + this.$vnode.key, {
      duration: 0,
      ease: "circ.easeInOut",
      x: this.pLocation[0],
      y: this.pLocation[1],
      width: this.pSize,
      height: this.pSize
    });
  },
  computed: {
    getIntroGifPath: function() {

      var _url = "";
 
      if (this.pProject.introGif )
      {
        //console.log(">>> Intro Gif")
        //console.log(this.pProject.introGif.url)
        _url = StrapiService.getApiHost(this.isLocal) + this.pProject.introGif.url
        //console.log("* intro gif " + _url)
      }

      return _url;
    },

    getGifSize: function() {

      //if (this.isOver) {
      //  console.log(this.getVideoWidth + "," + this.getVideoHeight)
      //}
      return {
        objectFit: 'cover',
        width: '100%',
        height: '100%'
      }
    },

    getHeaderStyle: function () {
      //var _s = window.innerHeight * 0.3;
      var _p = "absolute";
      if (!this.headerOpen) {
        _p = "fixed";
        //_s = this.closedSize;
      }

      return {
        position: _p,
        height: "30vh", //_s + "px", //"30vh",
        bottom: "0px",
        left: "0px",
        right: "0px",
        width: "100%",
        top: "0px",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "21",
      };
    },
    getCarouselWidth: function () {
      return window.innerWidth * (this.isMobile ? 0.8 : .7);
    },
    getCarouselHeight: function () {
      return (this.getCarouselWidth * 1080) / 1920; //400) / 575;
    },
    getBackButton: function () {
      return "< back";
    },
    getSrc: function () {
      return "https://player.vimeo.com/video/" + this.pProject.titleVideo;
    },
    /*getWindowWidth: function () {
      var _w = 0.75 * this.getWindowHeight;

      return _w;
    },
    getWindowHeight: function () {
      var _w = window.innerHeight * 0.95;

      if (_w > 1000) {
        _w = 1000;
      }

      return _w;
    },*/
    getProjectStudio: function () {
      if (this.pProject.adam_lassy_studio) {
        return this.pProject.adam_lassy_studio.name;
      }
      return "";
    },
    getProjectClient: function () {
      var _s = "";

      if (this.pProject.client) {
        _s = this.pProject.client;
      }
      if (this.pProject.year) {
        if (_s != "") {
          _s += " // ";
        }
        _s += this.pProject.year;
      }
      return _s;
    },
    getClass: function () {
      return "tween" + this.$vnode.key;
    },
    isSelected: function () {
      if (this.pSelectedProjectIndex == this.pIndex) {
        return true;
      } else {
        return false;
      }
    },

    getNameStyle: function () {
      var _style = {
        width: this.pSize + "px",
        height: this.pSize + "px",
        padding: "0px",
        textAlign: "left",
        fontWeight: "700",
        color: "#eeeeee",
      };
      return _style;
    },

    getContentStyle: function () {
      var _style = {
        width: "100%",
        position: "absolute",
        left: "0px",
        bottom: "0px",
        zIndex: "5",
        color: "#ffffff",
        background: "#22222288",
      };
      return _style;
    },

    getSquareStyle: function () {

      return {
        width: "100%",
        height: "100%",
        position: "absolute",
        overflow: "hidden",
        left: "0px", //this.pLocationX + "px",
        top: "0px", //this.pLocationY + "px",
        boxShadow: this.isOver ? "3px 3px 10px" : "",
      };
    },
    getMainHeight: function () {
      return window.innerHeight - 50;
    },
    getSubtitle: function () {
      var _t = "";
      if (this.pProject.subTitle) {
        _t = this.pProject.subTitle;
      }
      return _t;
    },
    getDate: function () {
      var _t = new Date();

      var _sd;
      if (this.pProject.date) {
        var _dat = this.pProject.date;
        var _arrD = _dat.split("-");

        _t.setMonth(_arrD[1] - 1);
        _t.setDate(_arrD[2]);
        _t.setFullYear(_arrD[0]);

        _sd =
          this.getMonthName(_t.getMonth()) +
          " " +
          _t.getDate() +
          ", " +
          _t.getFullYear();
      }

      //console.log(_sd);
      return _sd;
    },
    getMainCategory: function () {
      var _cat = "";
      if (this.pProject.madsci_primary_category) {
        _cat = this.pProject.madsci_primary_category.title;
      }
      return _cat;
    },
    getDescStyle: function () {
      return {
        backgroundColor: "#ffffff",
      }; //
    },

    getImgSize: function () {

      let _url = this.pProject.titleImg.url;
      if (this.pProject.titleImg.formats) {

        console.log("> Square Size : " + this.pSizeSquare)
        switch (this.isFlying ? 1 : this.pProject.pSizeSquare) {

          case 1:
            if (this.pProject.titleImg.formats.thumbnail) {
              _url = this.pProject.titleImg.formats.thumbnail.url;
            }
            break;

          case 2:
            if (this.pProject.titleImg.formats.small) {
              _url = this.pProject.titleImg.formats.small.url;
            }
            break;

          case 3:
            if (this.pProject.titleImg.formats.medium) {
              _url = this.pProject.titleImg.formats.medium.url;
            }
            break;
        }
      }

      console.log("img path > " + _url)
      return _url
    },

    getImgPath: function () {
      var _url = this.getImgSize;
      console.log (_url)
      return StrapiService.getApiHost(this.isLocal) + _url;
    },

    getBannerImgPath: function () {
      var _url = this.pProject.titleImg.url;

      return StrapiService.getApiHost(this.isLocal) + _url;
    },

    getVideoWidth: function () {
      var _p = this.pSize;
      if (this.pSizeSquare == 1) {
        _p *= 2.15;
      }

      if (
        !this.pProject.videoHeight ||
        this.pProject.videoWidth > this.pProject.videoHeight
      ) {
        return (_p * 1280) / 720;
      } else {
        return _p;
      }
      //return (_p * 1280) / 720;
    },

    getVideoHeight: function () {
      var _p = this.pSize;
      if (this.pSizeSquare == 1) {
        _p *= 2.15;
      }

      if (
        !this.pProject.videoHeight ||
        this.pProject.videoWidth > this.pProject.videoHeight
      ) {
        return _p;
      } else {
        return (this.pProject.videoHeight * _p) / this.pProject.videoWidth;
      }
      //return _p;
    },

    getImgOffset: function () {
      var _o = "50% 50%";
      if (this.pProject.titleImgVerticalOffset) {
        _o = "50% " + this.pProject.titleImgVerticalOffset + "%";
      }

      return _o;
    },
    getVideoOffset: function () {
      var _o = 0;
      if (this.pProject.videoVerticalOffset) {
        _o = this.pProject.videoVerticalOffset;
      }

      _o = -0.5 * (this.getVideoWidth - this.pSize);

      //console.log(_o);
      return _o;
    },
  },
  data() {
    return {
      keyIndex: 1,
      isOver: false,
      playerReady: false,
      playerLoaded: false,
      playerPlaying: false,
      imgLoaded: false,
      closeCount: 0,

      closedSize: 60,
      openSize: 120,
      headerOpen: true,
      selectedFilter: 0,
      isLocal: false,
      isFlying: false,

      isShowDetails: false,
      isMobile: false,

      isShowGrid: true
    };
  },
};
</script>

<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.squareOverlay {
  position: absolute;
  width: 100%;
  height: 80%;
  top: 0px;
  left: 0px;
}

.infoBottom {
  position: absolute;
  bottom: 2%;
}

.introVideoC {
  position: absolute;
  object-fit: cover;
  left:0px;
  top: 0px;
}

.nameBox {
  padding: 5%;
  padding-top: 3%;
  padding-left: 15px;
  height: 90%;
  position: relative;

}

.nameBox a {
  color: #eeeeee;
}

.nameBoxLinks {
  z-index: 500;
  width: 100%;
  height: 100%;
}

.nameBoxLinks a {
  color: #33cc33;
  font-weight:400;
}

.nameBoxLinks a:hover {
  text-decoration: underline;
}

.squareContent {
  cursor: pointer;
}

.title {
  line-height: 1.1;
  padding: 0px;
  font-weight: 600;
}

.subtitle {
  line-height: 1.1;
  font-size: 40px;
  padding-top: 20px;
  font-weight: 600;
}

.subtitle a {
  line-height: 1.1;
  font-size: 40px;
  padding-top: 20px;
  font-weight: 600;
  text-decoration: none;
}

.subtitle a:hover {
  line-height: 1.1;
  font-size: 40px;
  padding-top: 20px;
  font-weight: 600;
  text-decoration: underline;
  background-color: #00000000;
}

.titleSmall {
  line-height: 1.1;
  font-size: 20px;
  padding: 0px;
  font-weight: 600;
}

.subtitleSmall {
  line-height: 1.1;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 2px;
  font-weight: 500;
}

.roll {
  line-height: 1.1;
  font-size: 26px;
  padding-top: 30px;
  font-weight: 600;
}

.thinSubtitle {
  line-height: 1.1;
  font-weight: 300;
}

.aboutMe {
  font-weight:400;
  padding-right: 20px;
  padding-top: 5px;
}

.aboutMe a {
  color: #00bb00;
  font-weight: 400;
}

.projectNameTitle {
  font-weight:400;
  padding-top: 0px;
}

.projectParagraph {
  padding-top: 10px;
  padding-bottom: 10px;
}

.imgPair {
  position: relative;
  width: 100%;
  height: 300px;
  padding-top: 20px;
  padding-bottom: 10px;
}

.imgPairLeft {
  position: relative;
}

.imgPairRight {
  left: 50%;
  position: relative;
}

.imgFull {
  width: 100%;
}

.imgPairImg {
  height: 265px;
  width: 49%;
  left: 0px;
  top: 0px;
  object-fit: cover;
  position: absolute;
  border: solid 1px #33333366;
}

.imgPairCaption {
  position: absolute;
  padding-top: 0px;
  font-size: 12px;
  bottom: 0px;
  padding-bottom: 20px;
}

.imgCaption {
  position: relative;
  padding-top: 0px;
  top: -15px;
  font-size: 12px;
  padding-bottom: 20px;
}

.imgCaption a {
  font-size: 12px;
}

.private {
  border: solid 1px #ff0000ff;
  background: #ff5555dd;
  padding: 3px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.featuredInline {
  font-weight: 300;
}

.projectName {
  border: solid 2px #00000077;
  padding: 10px;
  text-align: left;
}

.teamRoll {
  padding-top: 20px;
  font-size: 16px;
  font-weight: 600;
}

.teamRollTitle {
  font-weight: 500;
}

.featured {
  border: solid 1px #ff0000ff;
  background: #ff5555cc;
  padding: 3px;
  padding-left: 4px;
  padding-right: 4px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
}
.projectDescFrame {
  position: absolute;
  width: 30.5vw;
  left: 68vw;
  height: 100%;
  padding-left: 7px;
  padding-right: 0px;
}

.projectSideFrame {
  position: fixed;
  width: 30.5vw;
  left: 68vw;
  padding-left: 13px;
  padding-right: 0px;
  padding-bottom: 60px;
}

.projectVideoFrame {
  width: 68vw;
  height: 100%;
  left: 0px;
  top: 0px;
  position: absolute;
  overflow: hidden;
}

.backButton {
  position: fixed;
  left: 0px;
  top: 31vh;
  font-size: 20px;
  font-weight: 600;
  padding: 8px;
  background-color: #ffffff66;
  z-index: 1000;
}

.projectTitleContent {
  position: relative;
  text-align: left;
  margin: auto;
  font-size: 22px;
  line-height: 1.4;
  
  height: 100%;
  padding-bottom: 0px;
  color: #eeeeee;
  bottom: 0px;
  z-index: 100;
  text-shadow: 0 3px 3px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.16);
}

.projectMainContent {
  position: relative;
  text-align: left;
  padding-top: 20px;
  margin: auto;
  font-size: 16px;
  line-height: 1.4;
  padding-bottom: 0px;
  color: #222222;
  top: 0px;
}

.contentBlock a {
  font-size: 16px;
}

.contentBlock a:hover {
text-decoration: underline;
}

.projectImg {
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  object-fit: cover;
  position: absolute;
}

.projectDate {
  position: absolute;
  bottom: 6%;
  left: 8%;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  font-style: oblique;
}

.projectDateSelected {
  position: relative;
  font-size: 16px;
  font-weight: 400;
  padding-top: 20px;
  color: #333333;
  font-style: oblique;
}

.projectCreditFrame {
  padding-top: 25px;
  font-size: 18px;
  line-height: 1.3;
}

.projectCreditTitle {
  font-size: 13px;
  font-weight: 700;
  padding-bottom: 10px;
}

.projectSubtitle {
  position: relative;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 400;
  margin-top: 15px;
  width: 80%;
  overflow: hidden;
}

.projectDesc {
  position: relative;
  width: 100%;
  height: 100%;
  border: solid 1px #33333366;
  text-align: left;
}

.projectContent {
  text-align: left;
  padding: 10px;
  position: relative;
  color: #eeeeee;
  font-weight: 600;
}

.projectContentStudio {
  font-weight: 600;
  padding-top: 11px;
}

.projectContentClient {
  font-weight: 400;
  padding-top: 3px;
}

.projectContentBack {
  text-align: left;
  padding: 0px;
  position: absolute;
  color: #eeeeee;
  width: 100%;
  bottom: 0px;
  background: #22222288;
}

.projectContentDetail {
  position: relative;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
}

.projectMainCategory {
  position: relative;
  font-size: 14px;
  font-weight: 700;
}

.projectDescTitle {
  position: relative;
  width: 80%;
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  font-size: 32px;
  font-weight: 700;
  color: #444444;
}

.categoryLink {
  font-size: 9px;
  font-weight: 700;
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  border: solid 1px #00000099;
  border-radius: 0px;
  text-align: center;
}

.categoryLinkPadding {
  padding: 1px;
}

.categoryLinkSelected {
  font-size: 11px;
  font-weight: 700;
  padding: 3px;
  padding-left: 5px;
  padding-right: 5px;
  border: solid 1px #00000099;
  border-radius: 0px;
  text-align: center;
}

.categoryLinkPaddingSelected {
  padding: 4px;
}

.categoryLinkFrameSelected {
  position: relative;
  top: 0px;
  right: 0px;
  top: 30px;
  left: -3px;
  padding-bottom: 25px;
}

.categoryLinkFrame {
  position: absolute;
  right: 0px;
  top: 20px;
  float: right;
  text-align: right;
  padding-right: 5%;
}

.projectTitleBuffer {
  padding-top: 20px;
}

.projectLineEvents {
  background-color: #00bb00;
}

.projectLineClients {
  background-color: #dddd00;
}

.projectLineResearch {
  background-color: #ffffff;
  border: solid 1px #00000055;
}

.projectLine {
  position: relative;
  height: 15px;
  width: 170px;
  top: 12px;
}

.emdash {
  position: relative;
  top: -0px;
}
</style>
